<template>
 <div id="app">
  <div class="form__field">
   <div class="cell">
    <input @keyup.enter="queryResults" class="ids_topicSearch" id="ctl00_ids_contentPlaceHolder_ids_topicSearch" name="ctl00$ids_contentPlaceHolder$ids_topicSearch" placeholder="Search Contents" type="text" v-model="search"/>
   </div>
   <div class="search_button" v-if="search">
    <button @click="clearResult" class="close-icon">
     &times;
    </button>
   </div>
   <div class="search_button">
    <button @click="queryResults">
     <i class="fa fa-search">
     </i>
    </button>
   </div>
  </div>
  <div class="col-1 l-pad-top" id="results">
   <div>
    <p class="toc-2-style" style="margin-bottom: 10px;">
     <strong v-if="resultsCount != 0">
      ({{resultsCount}}) Results Found
     </strong>
     <strong v-else-if="resultsActual">
      No Results Found
     </strong>
    </p>
   </div>
   <div v-for="result of resultsActual">
    <p class="toc-2-style">
     <a :href="result.link" :keywords="result.keywords" onclick="reload(this.href, this.getAttribute('keywords'))">
      {{result.title}}
     </a>
    </p>
    <p class="toc-3-style">
     {{result.desc}}
    </p>
   </div>
  </div>
  <div class="side-toc" v-if="!resultsActual">
   <p class="toc-1-style">
    <a href="cover.html" title="Rad C6100">
     Rad C6100
    </a>
   </p>
   <p class="toc-1-style">
    <a href="safety.html#safety_sk" title="Inform&aacute;cie o&nbsp;bezpečnosti">
     Inform&aacute;cie o&nbsp;bezpečnosti
    </a>
   </p>
   <div id="divd0e18">
    <p class="toc-2-style">
     <a href="safety.html#d0e23" title="Zauž&iacute;van&eacute; označenie">
      Zauž&iacute;van&eacute; označenie
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="learning-about-printer-chapter.html#learning-about-printer-chapter_sk" title="Obozn&aacute;menie sa s&nbsp;tlačiarňou">
     Obozn&aacute;menie sa s&nbsp;tlačiarňou
    </a>
   </p>
   <div id="divd0e187">
    <p class="toc-2-style">
     <a href="finding-information-about-printer-topic.html#finding-information-about-printer_sk" title="Vyhľad&aacute;vanie inform&aacute;ci&iacute; o&nbsp;tlačiarni">
      Vyhľad&aacute;vanie inform&aacute;ci&iacute; o&nbsp;tlačiarni
     </a>
    </p>
    <p class="toc-2-style">
     <a href="selecting-location-printer-topic.html#selecting-location-printer_sk" title="V&yacute;ber miesta pre tlačiareň">
      V&yacute;ber miesta pre tlačiareň
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configured-models-topic.html#configured-models_sk" title="Konfigur&aacute;cie tlačiarne">
      Konfigur&aacute;cie tlačiarne
     </a>
    </p>
    <p class="toc-2-style">
     <a href="attaching-cables-topic.html#attaching-cables_sk" title="Prip&aacute;janie k&aacute;blov">
      Prip&aacute;janie k&aacute;blov
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-control-panel-topic.html#using-control-panel_sk" title="Použ&iacute;vanie ovl&aacute;dacieho panela">
      Použ&iacute;vanie ovl&aacute;dacieho panela
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-status-power-button-and-indicator-light-topic.html#understanding-status-power-button-and-indicator-light_sk" title="Pochopenie v&yacute;znamu stavu tlačidla nap&aacute;jania a&nbsp;svetla indik&aacute;tora">
      Pochopenie v&yacute;znamu stavu tlačidla nap&aacute;jania a&nbsp;svetla indik&aacute;tora
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-home-screen-topic.html#using-home-screen_sk" title="Použ&iacute;vanie domovskej obrazovky">
      Použ&iacute;vanie domovskej obrazovky
     </a>
    </p>
    <p class="toc-2-style">
     <a href="menu-map-sfp-topic.html#menus-map-sfp_sk" title="Mapa pon&uacute;k">
      Mapa pon&uacute;k
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-menu-settings-page-topic.html#printing-menu-settings-page_sk" title="Tlač strany nastaven&iacute; ponuky">
      Tlač strany nastaven&iacute; ponuky
     </a>
    </p>
    <p class="toc-2-style">
     <a href="unacceptable-paper-topic.html#unacceptable-paper_sk" title="Neprijateľn&yacute; papier">
      Neprijateľn&yacute; papier
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-recycled-paper-topic.html#using-recycled-paper_sk" title="Použ&iacute;vanie recyklovan&eacute;ho papiera">
      Použ&iacute;vanie recyklovan&eacute;ho papiera
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="setting-up-using-home-screen-apps-chapter.html#setting-up-using-home-screen-apps-chapter_sk" title="Nastavenie a&nbsp;použ&iacute;vanie aplik&aacute;ci&iacute; na domovskej obrazovke">
     Nastavenie a&nbsp;použ&iacute;vanie aplik&aacute;ci&iacute; na domovskej obrazovke
    </a>
   </p>
   <div id="divd0e1161">
    <p class="toc-2-style">
     <a href="customizing-home-screen-topic.html#customizing-home-screen_sk" title="Prisp&ocirc;sobenie domovskej obrazovky">
      Prisp&ocirc;sobenie domovskej obrazovky
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-display-customization-topic.html#using-display-customization_sk" title="Použ&iacute;vanie funkcie Prisp&ocirc;sobenie displeja">
      Použ&iacute;vanie funkcie Prisp&ocirc;sobenie displeja
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-forms-and-favorites-topic.html#setting-up-forms-and-favorites_sk" title="Nastavenie formul&aacute;rov a&nbsp;obľ&uacute;ben&yacute;ch položiek">
      Nastavenie formul&aacute;rov a&nbsp;obľ&uacute;ben&yacute;ch položiek
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-eco-settings-topic.html#configuring-eco-settings_sk" title="Konfigur&aacute;cia &uacute;sporn&yacute;ch nastaven&iacute;">
      Konfigur&aacute;cia &uacute;sporn&yacute;ch nastaven&iacute;
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-customer-support-topic.html#using-customer-support_sk" title="Použ&iacute;vanie aplik&aacute;cie Podpora pre z&aacute;kazn&iacute;kov">
      Použ&iacute;vanie aplik&aacute;cie Podpora pre z&aacute;kazn&iacute;kov
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-qr-code-generator-topic.html#using-qr-code-generator_sk" title="Použ&iacute;vanie Tvorby k&oacute;dov QR">
      Použ&iacute;vanie Tvorby k&oacute;dov QR
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-device-quotas-topic.html#setting-up-device-quotas_sk" title="Nastavenie kv&oacute;t zariadenia">
      Nastavenie kv&oacute;t zariadenia
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-google-drive-topic.html#using-google-drive_sk" title="Použ&iacute;vanie služby Disk Google">
      Použ&iacute;vanie služby Disk Google
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adding-contacts-topic.html#d0e1389" title="Spr&aacute;va kontaktov">
      Spr&aacute;va kontaktov
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="setting-up-using-accessibility-features-chapter.html#setting-up-using-accessibility-features-chapter_sk" title="Nastavenie a&nbsp;použ&iacute;vanie funkci&iacute; zjednodu&scaron;enia ovl&aacute;dania">
     Nastavenie a&nbsp;použ&iacute;vanie funkci&iacute; zjednodu&scaron;enia ovl&aacute;dania
    </a>
   </p>
   <div id="divd0e1508">
    <p class="toc-2-style">
     <a href="enabling-magnification-mode-topic.html#enabling-magnification-mode_sk" title="Zapnutie režimu zv&auml;č&scaron;enia">
      Zapnutie režimu zv&auml;č&scaron;enia
     </a>
    </p>
    <p class="toc-2-style">
     <a href="activating-voice-guidance-topic.html#activating-voice-guidance_sk" title="Aktiv&aacute;cia hlasov&yacute;ch pokynov">
      Aktiv&aacute;cia hlasov&yacute;ch pokynov
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adjusting-voice-guidance-speech-rate-topic.html#adjusting-voice-guidance-speech-rate_sk" title="&Uacute;prava r&yacute;chlosti reči hlasov&yacute;ch pokynov">
      &Uacute;prava r&yacute;chlosti reči hlasov&yacute;ch pokynov
     </a>
    </p>
    <p class="toc-2-style">
     <a href="enabling-spoken-passwords-or-personal-identifcation-numbers-topic.html#enabling-spoken-passwords-or-personal-identifcation-numbers_sk" title="Zapnutie č&iacute;tania hesiel alebo osobn&yacute;ch identifikačn&yacute;ch č&iacute;sel">
      Zapnutie č&iacute;tania hesiel alebo osobn&yacute;ch identifikačn&yacute;ch č&iacute;sel
     </a>
    </p>
    <p class="toc-2-style">
     <a href="navigating-screen-using-gestures-topic.html#navigating-screen-using-gestures_sk" title="Navig&aacute;cia na obrazovke pomocou gest">
      Navig&aacute;cia na obrazovke pomocou gest
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-keyboard-on-display-topic.html#using-keyboard-on-display_sk" title="Použ&iacute;vanie kl&aacute;vesnice na displeji">
      Použ&iacute;vanie kl&aacute;vesnice na displeji
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="loading-paper-and-specialty-media-chapter.html#loading-paper-and-specialty-media-chapter_sk" title="Vkladanie papiera a&nbsp;&scaron;peci&aacute;lnych m&eacute;di&iacute;">
     Vkladanie papiera a&nbsp;&scaron;peci&aacute;lnych m&eacute;di&iacute;
    </a>
   </p>
   <div id="divd0e1711">
    <p class="toc-2-style">
     <a href="setting-paper-size-type-topic.html#setting-paper-size-type_sk" title="Nastavenie veľkosti a typu &scaron;peci&aacute;lnych m&eacute;di&iacute;">
      Nastavenie veľkosti a typu &scaron;peci&aacute;lnych m&eacute;di&iacute;
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-universal-paper-settings-m-topic.html#configuring-universal-paper-settings-m_sk" title="Konfigur&aacute;cia univerz&aacute;lnych nastaven&iacute; papiera">
      Konfigur&aacute;cia univerz&aacute;lnych nastaven&iacute; papiera
     </a>
    </p>
    <p class="toc-2-style">
     <a href="loading-trays-topic.html#loading-trays_sk" title="Vkladanie do z&aacute;sobn&iacute;kov">
      Vkladanie do z&aacute;sobn&iacute;kov
     </a>
    </p>
    <p class="toc-2-style">
     <a href="loading-multipurpose-feeder-topic.html#loading-multipurpose-feeder_sk" title="Vkladanie do viac&uacute;čelov&eacute;ho pod&aacute;vača">
      Vkladanie do viac&uacute;čelov&eacute;ho pod&aacute;vača
     </a>
    </p>
    <p class="toc-2-style">
     <a href="linking-and-unlinking-trays-topic.html#linking-and-unlinking-trays_sk" title="Prepojenie z&aacute;sobn&iacute;kov">
      Prepojenie z&aacute;sobn&iacute;kov
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="printing-chapter.html#printing-chapter_sk" title="Tlač">
     Tlač
    </a>
   </p>
   <div id="divd0e1897">
    <p class="toc-2-style">
     <a href="printing-from-computer-h2-topic.html#printing-from-computer-h2_sk" title="Tlač z poč&iacute;tača">
      Tlač z poč&iacute;tača
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-forms-topic.html#printing-forms_sk" title="Tlač formul&aacute;rov">
      Tlač formul&aacute;rov
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-mobile-device-using-lexmark-print-topic.html#d0e1948" title="Tlač z&nbsp;mobiln&eacute;ho zariadenia">
      Tlač z&nbsp;mobiln&eacute;ho zariadenia
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-flash-drive-h2-topic.html#printing-from-flash-drive-h2_sk" title="Tlač z&nbsp;pam&auml;ťovej jednotky flash">
      Tlač z&nbsp;pam&auml;ťovej jednotky flash
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-flash-drives-and-file-types-topic.html#supported-flash-drives-and-file-types_sk" title="Podporovan&eacute; pam&auml;ťov&eacute; jednotky flash a&nbsp;typy s&uacute;borov">
      Podporovan&eacute; pam&auml;ťov&eacute; jednotky flash a&nbsp;typy s&uacute;borov
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-confidential-jobs-topic.html#configuring-confidential-jobs_sk" title="Konfigur&aacute;cia d&ocirc;vern&yacute;ch &uacute;loh">
      Konfigur&aacute;cia d&ocirc;vern&yacute;ch &uacute;loh
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-confidential-and-other-held-jobs-h-topic.html#printing-confidential-and-other-held-jobs-h_sk" title="Tlač podržan&yacute;ch &uacute;loh">
      Tlač podržan&yacute;ch &uacute;loh
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-font-sample-list-h2-topic.html#printing-font-sample-list-h2_sk" title="Tlač zoznamu vzorky p&iacute;siem">
      Tlač zoznamu vzorky p&iacute;siem
     </a>
    </p>
    <p class="toc-2-style">
     <a href="canceling-print-job-topic.html#canceling-print-job_sk" title="Zru&scaron;enie tlačovej &uacute;lohy">
      Zru&scaron;enie tlačovej &uacute;lohy
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="securing-the-printer.html#securing-the-printer_sk" title="Zabezpečenie tlačiarne">
     Zabezpečenie tlačiarne
    </a>
   </p>
   <div id="divd0e2338">
    <p class="toc-2-style">
     <a href="locating-security-slot-topic.html#locating-security-slot_sk" title="Umiestnenie bezpečnostnej z&aacute;suvky">
      Umiestnenie bezpečnostnej z&aacute;suvky
     </a>
    </p>
    <p class="toc-2-style">
     <a href="erasing-printer-memory-topic.html#erasing-printer-memory_sk" title="Vymazanie pam&auml;te tlačiarne">
      Vymazanie pam&auml;te tlačiarne
     </a>
    </p>
    <p class="toc-2-style">
     <a href="erasing-printer-hard-disk-memory-topic.html#erasing-printer-hard-disk-memory_sk" title="Vymazanie pam&auml;te pevn&eacute;ho disku tlačiarne">
      Vymazanie pam&auml;te pevn&eacute;ho disku tlačiarne
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-printer-hard-disk-encryption-topic.html#configuring-printer-hard-disk-encryption_sk" title="Konfigur&aacute;cia &scaron;ifrovania pevn&eacute;ho disku tlačiarne">
      Konfigur&aacute;cia &scaron;ifrovania pevn&eacute;ho disku tlačiarne
     </a>
    </p>
    <p class="toc-2-style">
     <a href="restoring-factory-default-settings-topic.html#restoring-factory-default-settings_sk" title="Obnovenie predvolen&yacute;ch v&yacute;robn&yacute;ch nastaven&iacute;">
      Obnovenie predvolen&yacute;ch v&yacute;robn&yacute;ch nastaven&iacute;
     </a>
    </p>
    <p class="toc-2-style">
     <a href="statement-of-volatility-h2-topic.html#statement-of-volatility-h2_sk" title="Prehl&aacute;senie o nest&aacute;losti">
      Prehl&aacute;senie o nest&aacute;losti
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="maintain-printer-chapter.html#maintain-printer-chapter_sk" title="&Uacute;držba tlačiarne">
     &Uacute;držba tlačiarne
    </a>
   </p>
   <div id="divd0e2548">
    <p class="toc-2-style">
     <a href="adjusting-default-internal-speaker-volume-topic.html#d0e2553" title="&Uacute;prava hlasitosti reproduktora">
      &Uacute;prava hlasitosti reproduktora
     </a>
    </p>
    <p class="toc-2-style">
     <a href="connecting-printer-to-wireless-network-using-printer-control-panel-topic.html#d0e2645" title="Pripojenie do siete">
      Pripojenie do siete
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-serial-printing-topic.html#setting-up-serial-printing_sk" title="Nastavenie tlače cez s&eacute;riov&yacute; port (iba syst&eacute;m Windows)">
      Nastavenie tlače cez s&eacute;riov&yacute; port (iba syst&eacute;m Windows)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cleaning-printer-topic.html#cleaning-printer_sk" title="Čistenie tlačiarne">
      Čistenie tlačiarne
     </a>
    </p>
    <p class="toc-2-style">
     <a href="ordering-supplies-group.html#ordering-supplies-group_sk" title="Objedn&aacute;vanie s&uacute;čast&iacute; a&nbsp;spotrebn&eacute;ho materi&aacute;lu">
      Objedn&aacute;vanie s&uacute;čast&iacute; a&nbsp;spotrebn&eacute;ho materi&aacute;lu
     </a>
    </p>
    <p class="toc-2-style">
     <a href="replacing-developer-unit-topic.html#d0e3210" title="V&yacute;mena s&uacute;čast&iacute; a&nbsp;spotrebn&eacute;ho materi&aacute;lu">
      V&yacute;mena s&uacute;čast&iacute; a&nbsp;spotrebn&eacute;ho materi&aacute;lu
     </a>
    </p>
    <p class="toc-2-style">
     <a href="storing-supplies-topic.html#storing-supplies_sk" title="Skladovanie spotrebn&eacute;ho materi&aacute;lu">
      Skladovanie spotrebn&eacute;ho materi&aacute;lu
     </a>
    </p>
    <p class="toc-2-style">
     <a href="moving-the-printer-group.html#d0e3680" title="Premiestnenie tlačiarne">
      Premiestnenie tlačiarne
     </a>
    </p>
    <p class="toc-2-style">
     <a href="saving-energy-paper.html#d0e3736" title="&Uacute;spora energie a&nbsp;papiera">
      &Uacute;spora energie a&nbsp;papiera
     </a>
    </p>
    <p class="toc-2-style">
     <a href="recycling.html#d0e3873" title="Recykl&aacute;cia">
      Recykl&aacute;cia
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="clearing-jams-chapter.html#clearing-jams-chapter_sk" title="Odstraňovanie zaseknut&iacute;">
     Odstraňovanie zaseknut&iacute;
    </a>
   </p>
   <div id="divd0e3927">
    <p class="toc-2-style">
     <a href="avoiding-jams-topic.html#avoiding-jams_sk" title="Predch&aacute;dzanie zaseknutiu papiera">
      Predch&aacute;dzanie zaseknutiu papiera
     </a>
    </p>
    <p class="toc-2-style">
     <a href="identifying-jam-locations-topic.html#identifying-jam-locations_sk" title="Identifik&aacute;cia miest zaseknutia">
      Identifik&aacute;cia miest zaseknutia
     </a>
    </p>
    <p class="toc-2-style">
     <a href="jam-in-trays-topic.html#jam-in-trays_sk" title="Zaseknutie papiera v&nbsp;z&aacute;sobn&iacute;koch">
      Zaseknutie papiera v&nbsp;z&aacute;sobn&iacute;koch
     </a>
    </p>
    <p class="toc-2-style">
     <a href="jams-in-mpf-topic.html#jams-in-mpf_sk" title="Zaseknutie papiera vo viac&uacute;čelovom pod&aacute;vači">
      Zaseknutie papiera vo viac&uacute;čelovom pod&aacute;vači
     </a>
    </p>
    <p class="toc-2-style">
     <a href="jam-in-standard-bin-topic.html#jam-in-standard-bin_sk" title="Zaseknutie papiera v&nbsp;&scaron;tandardnej priehradke">
      Zaseknutie papiera v&nbsp;&scaron;tandardnej priehradke
     </a>
    </p>
    <p class="toc-2-style">
     <a href="jam-in-door-b-topic.html#jam-in-door-b_sk" title="Zaseknutie papiera v&nbsp;dvierkach B">
      Zaseknutie papiera v&nbsp;dvierkach B
     </a>
    </p>
    <p class="toc-2-style">
     <a href="jam-in-finisher-bin-topic.html#jam-in-finisher-bin_sk" title="Zaseknutie papiera v&nbsp;priehradke dokončovača">
      Zaseknutie papiera v&nbsp;priehradke dokončovača
     </a>
    </p>
    <p class="toc-2-style">
     <a href="staple-jam-door-g-topic.html#staple-jam-door-g_sk" title="Zaseknut&eacute; spinky v&nbsp;dvierkach G">
      Zaseknut&eacute; spinky v&nbsp;dvierkach G
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="troubleshooting-chapter.html#troubleshooting-chapter_sk" title="Rie&scaron;enie probl&eacute;mov">
     Rie&scaron;enie probl&eacute;mov
    </a>
   </p>
   <div id="divd0e4271">
    <p class="toc-2-style">
     <a href="trb-cannot-open-embedded-web-server-topic.html#d0e4274" title="Probl&eacute;my so sieťov&yacute;m pripojen&iacute;m">
      Probl&eacute;my so sieťov&yacute;m pripojen&iacute;m
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-detect-internal-option-topic.html#d0e4489" title="Probl&eacute;my s&nbsp;hardv&eacute;rov&yacute;mi voliteľn&yacute;mi prvkami">
      Probl&eacute;my s&nbsp;hardv&eacute;rov&yacute;mi voliteľn&yacute;mi prvkami
     </a>
    </p>
    <p class="toc-2-style">
     <a href="message-replace-cartridge-printer-region-mismatch-topic.html#d0e4761" title="Probl&eacute;my so&nbsp;spotrebn&yacute;m materi&aacute;lom">
      Probl&eacute;my so&nbsp;spotrebn&yacute;m materi&aacute;lom
     </a>
    </p>
    <p class="toc-2-style">
     <a href="solving-printer-problems.html#solving-printer-problems_sk" title="Probl&eacute;my s&nbsp;pod&aacute;van&iacute;m papiera">
      Probl&eacute;my s&nbsp;pod&aacute;van&iacute;m papiera
     </a>
    </p>
    <p class="toc-2-style">
     <a href="solving-printing-problems.html#solving-printing-problems_sk" title="Probl&eacute;my s&nbsp;tlačou">
      Probl&eacute;my s&nbsp;tlačou
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adjusting-toner-darkness-topic.html#d0e7303" title="Probl&eacute;my s&nbsp;kvalitou farieb">
      Probl&eacute;my s&nbsp;kvalitou farieb
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-contacting-customer-support-topic.html#trb-contacting-customer-support_sk" title="Kontaktovanie podpory pre z&aacute;kazn&iacute;kov">
      Kontaktovanie podpory pre z&aacute;kazn&iacute;kov
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="upgrading-migrating-chapter.html#upgrading-migrating-chapter_sk" title="Inov&aacute;cia a&nbsp;migr&aacute;cia">
     Inov&aacute;cia a&nbsp;migr&aacute;cia
    </a>
   </p>
   <div id="divd0e7537">
    <p class="toc-2-style">
     <a href="available-internal-options-topic.html#d0e7540" title="Hardv&eacute;r">
      Hardv&eacute;r
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-printer-software-topic.html#d0e7866" title="Softv&eacute;r">
      Softv&eacute;r
     </a>
    </p>
    <p class="toc-2-style">
     <a href="exporting-importing-configuration-using-ews-winners-circle-topic.html#d0e7942" title="Firmv&eacute;r">
      Firmv&eacute;r
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="laser_ug_notices.html#laser_ug_notices_sk" title="Upozornenia">
     Upozornenia
    </a>
   </p>
   <div id="divd0e8011">
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e8014" title="Inform&aacute;cie o&nbsp;produkte">
      Inform&aacute;cie o&nbsp;produkte
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e8031" title="Pozn&aacute;mka k&nbsp;vydaniu">
      Pozn&aacute;mka k&nbsp;vydaniu
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#trademarks_sk" title="Ochrann&eacute; zn&aacute;mky">
      Ochrann&eacute; zn&aacute;mky
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#licensing-notices_sk" title="Inform&aacute;cie o&nbsp;licencovan&iacute;">
      Inform&aacute;cie o&nbsp;licencovan&iacute;
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#noise-emission-levels_sk" title="Hladiny emisi&iacute; hluku">
      Hladiny emisi&iacute; hluku
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e8119" title="Environmental labeling for packaging">
      Environmental labeling for packaging
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e8146" title="Nab&iacute;jateľn&aacute; l&iacute;tium-i&oacute;nov&aacute; bat&eacute;ria">
      Nab&iacute;jateľn&aacute; l&iacute;tium-i&oacute;nov&aacute; bat&eacute;ria
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#eu-battery-directive-2023-1542_sk" title="Nariadenie (E&Uacute;) 2023/1542">
      Nariadenie (E&Uacute;) 2023/1542
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#returning-lexmark-cartridges-for-reuse-or-recycling_sk" title="Vr&aacute;tenie kaziet Lexmark na op&auml;tovn&eacute; použitie alebo recykl&aacute;ciu">
      Vr&aacute;tenie kaziet Lexmark na op&auml;tovn&eacute; použitie alebo recykl&aacute;ciu
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#static-sensitivity-notice_sk" title="Upozornenie o&nbsp;statickej citlivosti">
      Upozornenie o&nbsp;statickej citlivosti
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#temperature-information_sk" title="Inform&aacute;cie o teplot&aacute;ch">
      Inform&aacute;cie o teplot&aacute;ch
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#laser-notice_sk" title="Vyhl&aacute;senie o&nbsp;laserovom zariaden&iacute;">
      Vyhl&aacute;senie o&nbsp;laserovom zariaden&iacute;
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#laser-advisory-label_sk" title="&Scaron;t&iacute;tok s odpor&uacute;čaniami v&nbsp;s&uacute;vislosti s použ&iacute;van&iacute;m laserov&eacute;ho zariadenia">
      &Scaron;t&iacute;tok s odpor&uacute;čaniami v&nbsp;s&uacute;vislosti s použ&iacute;van&iacute;m laserov&eacute;ho zariadenia
     </a>
    </p>
   </div>
  </div>
 </div>
</template>
<script>
 import output from './output.json';

const fuzzysort = require('fuzzysort');
const lunr = require("lunr")
require("lunr-languages/lunr.stemmer.support.js")(lunr)
require('lunr-languages/lunr.multi')(lunr)
require("lunr-languages/tinyseg.js")(lunr)
require("lunr-languages/lunr.de.js")(lunr)
require("lunr-languages/lunr.es.js")(lunr)
require("lunr-languages/lunr.fr.js")(lunr)
require("lunr-languages/lunr.it.js")(lunr)
require("lunr-languages/lunr.ja.js")(lunr)
require("lunr-languages/lunr.pt.js")(lunr)

export default {
  name: 'app',
  data() {
    return {
        search: '',
        resultsActual: '',
        list: output,
        resultsCount: 0,
    }
  },

  methods: { queryResults() {

      if (this.search.trim() === ''){
        return  '';
      }
    //   else if(this.search.trim().length < 3){
    //     this.resultsActual = new Array();
    //     this.resultsCount = 0;
    //   }
      else {
        var documents = this.list;

        var idx = lunr(function () {
            this.use(lunr.ja);
            this.use(lunr.multiLanguage('en', 'de', 'es', 'fr', 'it', 'ja', 'pt'))
            this.ref('UUID');
            this.field('title');
            this.field('descFull');
            this.metadataWhitelist = ['position'];

            documents.forEach(function (doc) {
                        this.add(doc)
                    },this);
            });
        

        var searchTerms = this.search.replace(/[`~!#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\/]/gi, ' ').trim().replace(/\s\s+/g, " ");
        // var searchTerms = this.search;
        searchTerms = this.removeStopWords(searchTerms);
        var searchRawTerms = searchTerms;
        // searchTerms  =  searchTerms.split(" ").join(" +");
        // searchTerms = searchTerms.startsWith(" +") ? searchTerms : "+" + searchTerms;

        console.log(searchTerms);
        var results = idx.search(searchTerms);

        console.log (results);

        results = results.map(res => {
            var linkRes =  documents.find(elem => elem.UUID == res.ref);
            var keywords_array = new Array();
            var keywords_arrays = new Array();
            var keywords_arrays_title = new Array();

            Object.keys(res.matchData.metadata).map(kys => {
                var positions_title = res.matchData.metadata[kys].title;
                var positions_desc = res.matchData.metadata[kys].descFull;

                if(typeof positions_title !== 'undefined' ){
                    positions_title.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays_title.push(val[0],val[1]);
                    });
                }

                if(typeof positions_desc !== 'undefined' ){
                    positions_desc.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays.push(val[0],val[1]);
                    });
                }
            });

            

            res.link = linkRes.link;
            res.desc = linkRes.desc;
            res.title = linkRes.title;
            res.full = linkRes.descFull;
            res.titleArray = keywords_arrays_title;
            res.descArray = keywords_arrays;
            keywords_array = keywords_array.filter(function(item, index){ 
                return searchRawTerms.indexOf(item) >= 0;
            });
            var keywords_set = new Set(keywords_array);
            res.keywords = [...keywords_set].toString();
            // res.keywords = ["ramon","joe","gudz"]
            return res;
        });
        
        var existingPagesInResult = new Array();
        

       
        results = results.filter(function(item, index){
                
            if(existingPagesInResult.includes(item.link)){
                
                return false;
            }
            else { 
                existingPagesInResult.push(item.link);
                return true;
            }

            if(res.keywords == ""){
                return false;
            }
        });

        

        console.log (results);
        this.resultsActual = results;
        this.resultsCount = results.length;
      }
    },

    clearResult: function(){
        this.search = "";
        this.resultsActual = undefined;
        this.resultsCount = 0;
        reload("cover.html", "");
       
    },  

    removeStopWords: function(queryString) {
        const stopWords = ['i', 'me', 'my', 'myself', 'we', 'our', 'ours', 'ourselves', 'you', "you're", "you've", "you'll", "you'd", 'your', 'yours', 'yourself', 'yourselves', 
        'he', 'him', 'his', 'himself', 'she', "she's", 'her', 'hers', 'herself', 'it', "it's", 'its', 'itself', 'they', 'them', 'their', 'theirs', 'themselves', 'what', 'which', 
        'who', 'whom', 'this', 'that', "that'll", 'these', 'those', 'am', 'is', 'are', 'was', 'were', 'be', 'been', 'being', 'have', 'has', 'had', 'having', 'do', 'does', 'did', 
        'doing', 'a', 'an', 'the', 'and', 'but', 'if', 'or', 'because', 'as', 'until', 'while', 'of', 'at', 'by', 'for', 'with', 'about', 'against', 'between', 'into', 'through', 
        'during', 'before', 'after', 'above', 'below', 'to', 'from', 'up', 'down', 'in', 'out', 'on', 'off', 'over', 'under', 'again', 'further', 'then', 'once', 'here', 'there', 
        'when', 'where', 'why', 'how', 'all', 'any', 'both', 'each', 'few', 'more', 'most', 'other', 'some', 'such', 'no', 'nor', 'not', 'only', 'own', 'same', 'so', 'than', 'too', 
        'very', 's', 't', 'can', 'will', 'just', 'don', "don't", 'should', "should've", 'now', 'd', 'll', 'm', 'o', 're', 've', 'y', 'ain', 'aren', "aren't", 'couldn', "couldn't", 
        'didn', "didn't", 'doesn', "doesn't", 'hadn', "hadn't", 'hasn', "hasn't", 'haven', "haven't", 'isn', "isn't", 'ma', 'mightn', "mightn't", 'mustn', "mustn't", 'needn', 
         "needn't", 'shan', "shan't", 'shouldn', "shouldn't", 'wasn', "wasn't", 'weren', "weren't", 'won', "won't", 'wouldn', "wouldn't"]

        var cleanQueryString = new Array();
        queryString.split(" ").forEach(word => {
             if(!stopWords.includes(word)) {
                 cleanQueryString.push(word);
             }
        });

        return cleanQueryString.join(" ");
    },
    
  }
}
</script>


// WEBPACK FOOTER //
// src/App.vue